import { render, staticRenderFns } from "./WorkflowSteps.vue?vue&type=template&id=07205d2e&scoped=true"
import script from "./WorkflowSteps.vue?vue&type=script&lang=js"
export * from "./WorkflowSteps.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSteps.vue?vue&type=style&index=0&id=07205d2e&prod&lang=less"
import style1 from "./WorkflowSteps.vue?vue&type=style&index=1&id=07205d2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07205d2e",
  null
  
)

export default component.exports